import React, { useEffect, useState } from "react";
import api from "../lib/api";

export default function CustomerOperations() {
  const [data, setData] = useState({ businesses: [], conversations: [] });
  const [selected, setSelected] = useState("ALL");
  const [active, setActive] = useState(null);
  const [detail, setDetail] = useState(null);
  const [loadingDetail, setLoadingDetail] = useState(false);

  useEffect(() => {
    api.get("/customer-operations/my-inbox").then(r => setData(r.data));
  }, []);

  const openConversation = async (row) => {
    setActive(row);
    setLoadingDetail(true);
    try {
      const r = await api.get(`/customer-operations/${row.business_code}/conversations/${row.id}`);
      setDetail(r.data);
    } finally {
      setLoadingDetail(false);
    }
  };

  const rows = selected === "ALL"
    ? data.conversations
    : data.conversations.filter(x => x.business_code === selected);

  return (
    <div className="space-y-6">
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-slate-500">Human + AI Operations</p>
        <h1 className="text-2xl font-semibold text-white mt-1">My Inbox</h1>
        <p className="text-sm text-slate-500 mt-1">
          One work queue across only the businesses this user is authorized to handle.
        </p>
      </div>

      <div className="flex flex-wrap gap-2">
        <button onClick={() => setSelected("ALL")}
          className="rounded-lg border border-white/10 px-3 py-2 text-xs text-slate-300">
          All businesses
        </button>
        {data.businesses.map(b => (
          <button key={b.code} onClick={() => setSelected(b.code)}
            className="rounded-lg border border-white/10 px-3 py-2 text-xs text-slate-300">
            {b.name}
          </button>
        ))}
      </div>

      <div className="rounded-xl border border-white/10 bg-[#0B101C] overflow-hidden">
        <div className="grid grid-cols-4 gap-3 px-4 py-3 text-xs uppercase tracking-wider text-slate-600 border-b border-white/10">
          <span>Business</span><span>Channel</span><span>Customer</span><span>Status</span>
        </div>
        {rows.map(row => (
          <button type="button" key={row.id} onClick={() => openConversation(row)}
            className="w-full text-left grid grid-cols-4 gap-3 px-4 py-4 text-sm border-b border-white/5 last:border-0 hover:bg-white/[0.03]">
            <span className="text-white">{row.business_name}</span>
            <span className="text-slate-400">{row.channel_code || "—"}</span>
            <span className="text-slate-300">{row.contact_name || row.contact_id || "Customer"}</span>
            <span className="text-slate-500">{row.status}</span>
          </button>
        ))}
        {!rows.length && <div className="px-4 py-10 text-center text-sm text-slate-600">No open conversations.</div>}
      </div>

      {active && (
        <div className="rounded-xl border border-white/10 bg-[#0B101C] p-5 space-y-4">
          <div className="flex items-start justify-between gap-4">
            <div>
              <p className="text-xs uppercase tracking-wider text-slate-600">Conversation Detail</p>
              <h2 className="text-lg font-semibold text-white mt-1">
                {active.sender_name || active.contact_name || "Customer"}
              </h2>
              <p className="text-xs text-slate-500 mt-1">
                {active.business_name} · {active.channel_code || "Unknown channel"} · {active.status}
              </p>
            </div>
            <button type="button" onClick={() => { setActive(null); setDetail(null); }}
              className="text-xs text-slate-400 hover:text-white">Close</button>
          </div>

          {loadingDetail && <p className="text-sm text-slate-500">Loading conversation…</p>}
          {!loadingDetail && detail && (
            <>
              <div className="grid gap-3 md:grid-cols-2">
                <div className="rounded-lg border border-white/10 p-3">
                  <p className="text-xs text-slate-600">Linked Lead</p>
                  <p className="text-sm text-slate-300 mt-1">{detail.lead?.name || detail.conversation?.lead_id || "Not linked"}</p>
                </div>
                <div className="rounded-lg border border-white/10 p-3">
                  <p className="text-xs text-slate-600">Assigned CS</p>
                  <p className="text-sm text-slate-300 mt-1">{detail.conversation?.owner_user_ref || "Unassigned"}</p>
                </div>
              </div>
              <div className="space-y-2">
                {(detail.messages || []).map(message => (
                  <div key={message.id} className="rounded-lg border border-white/10 p-3">
                    <div className="flex justify-between gap-3 text-xs text-slate-600">
                      <span>{message.direction}</span><span>{message.send_state}</span>
                    </div>
                    <p className="text-sm text-slate-300 mt-2 whitespace-pre-wrap">{message.text}</p>
                  </div>
                ))}
                {!(detail.messages || []).length && <p className="text-sm text-slate-600">No messages.</p>}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}
